// extracted by mini-css-extract-plugin
export default {"pop-up":"pop-up--YtcnE","popUp":"pop-up--YtcnE","bg":"bg--Ox3Mh","content":"content--FFFIO","close-icon":"close-icon--lNd3a","closeIcon":"close-icon--lNd3a"};